module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-control restricted-textarea"
  }, [_c('label', {
    class: _vm.getColor(),
    attrs: {
      "data-limit": ((_vm.inputValue.length) + "/" + _vm.limit)
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: ("" + _vm.required)
      }),
      expression: "{required: `${required}`}"
    }],
    class: _vm.textColorClass,
    attrs: {
      "rows": "4",
      "placeholder": _vm.placeholder,
      "maxlength": _vm.limit,
      "disabled": _vm.isDisabled
    },
    domProps: {
      "value": (_vm.inputValue)
    },
    on: {
      "focus": _vm.enableShowLimit,
      "blur": _vm.disableShowLimit,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.showNotice) ? _c('div', [_c('p', {
    staticClass: "notice-message"
  }, [_vm._v("Comments should not be longer than " + _vm._s(_vm.limit) + " characters")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33d98090","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formControls/RestrictedTextArea.vue
// module id = 2136
// module chunks = 1